import OwnerReviewCampaign from './components/OwnerReviewCampaign';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import values from 'lodash/values';
import {
  loadCampaign,
  updateCampaign,
  loadEngagementsForCampaign,
  loadActiveUser,
  approveCampaign,
  loadRetailers,
  rejectCampaign,
  loadBrand,
  loadPublishersForCampaign,
  loadCampaignHistory,
  loadCampaignReach
} from '../../shared/redux/entities/actions';

import {
  showNotification
} from '../../shared/redux/notifications/actions';

import { 
  loadListOfStates,
  loadListOfStatesAndDMAs
} from '../../shared/redux/audience/actions';

import { getActiveAgencyUser } from '../../shared/redux/selectors';


import './assets/OwnerReviewCampaign.css';

function getEngagementsForCampaignId(state,campaignId){
  return values(get(state,['entities','engagements'],{}))
    .filter((e) => e.campaignId === campaignId)
    .sort((a,b) => a.ordinal - b.ordinal);
}

function getBrandForCampaignId(state,campaignId){
  const companyId = get(state,['entities','campaigns',campaignId,'companyId']);

  return get(state,['entities','companies',companyId]);
}

function getAgencyForCampaignId(state,campaignId){
  const agencyId = get(state,['entities','campaigns',campaignId,'agencyId']);

  return get(state,['entities','agencies',agencyId]);  
}

function getPaymentMethodForCampaignId(state,campaignId){
  const paymentMethodId = get(state,['entities','campaigns',campaignId,'paymentMethodId']);

  return get(state,['entities','paymentMethods',paymentMethodId],{});
}

function getPublishersForCampaignId(state,campaignId){
  const companyId = get(state,['entities','campaigns',campaignId,'companyId']);

  const matchingRetailers = values(state.entities.companies)
    .filter((c) => !c.isBrand)
    .filter((c) => (c.approvedBrandIds || []).indexOf(companyId) >= 0);

  return matchingRetailers;
}

function getIsPublishingToEntireNetworkForCampaignId(state,campaignId){
  const companyId = get(state,['entities','campaigns',campaignId,'companyId']);

  const allRetailers = values(state.entities.companies)
    .filter((c) => !c.isBrand);

  const matchingRetailers = allRetailers
    .filter((c) => (c.approvedBrandIds || []).indexOf(companyId) >= 0);

  return allRetailers.length === matchingRetailers.length; 
}


function getCampaignHistory(state,campaignId){
  const campaign = get(state,['entities','campaigns',campaignId]),
    history = [];

  if(!campaign) return null

  if(campaign.history) history.push(...campaign.history);

  return history.sort((a,b) => b.timestamp - a.timestamp);
}

function getRetailers(state){
  return values(state.entities.companies).filter((c) => !c.isBrand)
}

function mapStateToProps(state,props){
  const campaignId = props.match.params.campaignId,
    activeUserId = get(state,['entities','activeUserId']);

  return {
    campaignId:campaignId,
    paymentMethodId:get(state,['entities','campaigns',campaignId,'paymentMethodId']),
    paymentMethod:getPaymentMethodForCampaignId(state,campaignId),
    user:getActiveAgencyUser(state),
    needsAuth:get(state,['entities',activeUserId]) === null,
    pathname:props.location.pathname,
    campaign:get(state,['entities','campaigns',campaignId]),
    engagements:getEngagementsForCampaignId(state,campaignId),
    retailers:getRetailers(state),
    history:getCampaignHistory(state,campaignId),
    isPublishingToEntireNetwork:getIsPublishingToEntireNetworkForCampaignId(state,campaignId),
    brand:getBrandForCampaignId(state,campaignId),
    agency:getAgencyForCampaignId(state,campaignId),
    possibleStates:state.audience.states,
    possibleGeoFilters:state.audience.geofilters
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    updateCampaign,
    loadCampaign,
    loadActiveUser,
    loadEngagementsForCampaign,
    approveCampaign,
    rejectCampaign,
    loadBrand,
    showNotification,
    loadRetailers,
    loadPublishersForCampaign,
    loadCampaignHistory,
    loadListOfStates,
    loadCampaignReach,
    loadListOfStatesAndDMAs
  },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(OwnerReviewCampaign);



// WEBPACK FOOTER //
// ./src/routes/OwnerReviewCampaign/index.js